import React from "react";
import { Box, Container, Button, Grid } from "@mui/material";

function HomePage() {
  const restaurants = [
    {
      name: "La esquinita de blai",
      logo: "images/logo-esq-header.png",
      link: "/esquinita",
      color: "#8F1025",
      hoverColor: "#72101F",
    },
    {
      name: "Blai 9",
      logo: "images/logo-b9-header.png",
      link: "/blai9",
      color: "#0f0f0f",
      hoverColor: "#3b3b3b",
    },
    {
      name: "Emporium",
      logo: "images/logo-emporium.png",
      link: "/emporium",
      color: "#31688d",
      hoverColor: "#19354D",
    },
  ];

  return (
    <div
      style={{
        background:
          "radial-gradient(circle, rgba(230, 236, 250, 1) 1%, rgba(245, 245, 245, 1) 100%)",
        minHeight: "100vh",
      }}
    >
      <Container
        sx={{
          padding: 6,
          textAlign: "center",
        }}
      >
        {/* Logo de la empresa */}
        <Box
          component="img"
          src="images/logo-bcn.png"
          alt="Logo de la empresa"
          sx={{
            width: { xs: "80%", sm: "50%", md: "40%" },
            maxWidth: 300,
            display: "block",
            margin: "0 auto",
          }}
        />

        {/* Botones de restaurantes */}
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: 4,
            justifyContent: "center",
          }}
        >
          {restaurants.map((restaurant) => (
            <Grid item xs={6} sm={3} key={restaurant.name}>
              <Button
                href={restaurant.link}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 2,
                  width: "100%",
                  minHeight: 150,
                  borderRadius: 3,
                  boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                  backgroundColor: restaurant.color,
                  transition: "all 0.25s ease",

                  "&:hover": {
                    backgroundColor: restaurant.hoverColor,
                    transform: "translateY(-4px)",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.20)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={restaurant.logo}
                  alt={restaurant.name}
                  sx={{
                    width: "120px",
                    maxWidth: "90%",
                    height: "auto",
                  }}
                />
              </Button>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}

export default HomePage;
